// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   FATAL ERROR PAGE — ACCESSIBILITY-FIRST
   Self-contained: no dependency on app CSS vars (they may not be loaded yet).
   ========================================================================== */

.a11y-error {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  margin: 0;
  padding: 2rem;
  box-sizing: border-box;
  background: #111;
  color: #e0e0e0;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
}

/* ---------- Card ---------- */

.a11y-error__card {
  max-width: 620px;
  width: 100%;
  padding: 2.5rem;
  border: 2px solid #ba160c;
  border-radius: 8px;
  background: #1a1a1a;
}

/* ---------- Header / Logo ---------- */

.a11y-error__header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #333;
}

.a11y-error__logo {
  max-width: 220px;
  height: auto;
  filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.75));
}

/* ---------- Alert content ---------- */

.a11y-error__icon {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.a11y-error__title {
  margin: 0 0 0.75rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
}

.a11y-error__description {
  margin: 0 0 1.5rem;
  font-size: 1rem;
  color: #bbb;
}

.a11y-error__section-title {
  margin: 0 0 0.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #e0e0e0;
}

.a11y-error__list {
  margin: 0 0 1.5rem;
  padding-left: 1.25rem;
}

.a11y-error__list li {
  margin-bottom: 0.4rem;
}

.a11y-error__list li::marker {
  color: #ba160c;
}

/* ---------- Technical detail ---------- */

.a11y-error__detail {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #333;
}

.a11y-error__detail-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.a11y-error__detail-value {
  display: block;
  padding: 0.5rem 0.75rem;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
  font-size: 0.85rem;
  color: #e88;
  background: #222;
  border-radius: 4px;
  word-break: break-word;
}

/* ---------- Footer ---------- */

.a11y-error__footer {
  left: 0px;
  padding-left: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #333;
  font-size: 0.8rem;
  color: #666;
}

.a11y-error__version {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
}

.a11y-error__copyright {
  text-align: center;
}

/* ---------- Links & focus ---------- */

.a11y-error a:focus-visible {
  outline: 2px solid #ba160c;
  outline-offset: 2px;
}

.a11y-error a {
  color: #6ea8fe;
}

.a11y-error a:hover {
  color: #9ec5fe;
}`, "",{"version":3,"sources":["webpack://./src/engine/rendering/a11y-error.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,8FAA8F;EAC9F,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wCAAwC;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gDAAgD;AAClD;;AAEA,wCAAwC;;AAExC;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;;AAE3C;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,qFAAqF;EACrF,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,iCAAiC;;AAEjC;EACE,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wCAAwC;;AAExC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* ==========================================================================\n   FATAL ERROR PAGE — ACCESSIBILITY-FIRST\n   Self-contained: no dependency on app CSS vars (they may not be loaded yet).\n   ========================================================================== */\n\n.a11y-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  margin: 0;\n  padding: 2rem;\n  box-sizing: border-box;\n  background: #111;\n  color: #e0e0e0;\n  font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* ---------- Card ---------- */\n\n.a11y-error__card {\n  max-width: 620px;\n  width: 100%;\n  padding: 2.5rem;\n  border: 2px solid #ba160c;\n  border-radius: 8px;\n  background: #1a1a1a;\n}\n\n/* ---------- Header / Logo ---------- */\n\n.a11y-error__header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1.25rem;\n  border-bottom: 1px solid #333;\n}\n\n.a11y-error__logo {\n  max-width: 220px;\n  height: auto;\n  filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.75));\n}\n\n/* ---------- Alert content ---------- */\n\n.a11y-error__icon {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.a11y-error__title {\n  margin: 0 0 0.75rem;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.a11y-error__description {\n  margin: 0 0 1.5rem;\n  font-size: 1rem;\n  color: #bbb;\n}\n\n.a11y-error__section-title {\n  margin: 0 0 0.5rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #e0e0e0;\n}\n\n.a11y-error__list {\n  margin: 0 0 1.5rem;\n  padding-left: 1.25rem;\n}\n\n.a11y-error__list li {\n  margin-bottom: 0.4rem;\n}\n\n.a11y-error__list li::marker {\n  color: #ba160c;\n}\n\n/* ---------- Technical detail ---------- */\n\n.a11y-error__detail {\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #333;\n}\n\n.a11y-error__detail-label {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.a11y-error__detail-value {\n  display: block;\n  padding: 0.5rem 0.75rem;\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, Courier, monospace;\n  font-size: 0.85rem;\n  color: #e88;\n  background: #222;\n  border-radius: 4px;\n  word-break: break-word;\n}\n\n/* ---------- Footer ---------- */\n\n.a11y-error__footer {\n  left: 0px;\n  padding-left: 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #333;\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.a11y-error__version {\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, Courier, monospace;\n}\n\n.a11y-error__copyright {\n  text-align: center;\n}\n\n/* ---------- Links & focus ---------- */\n\n.a11y-error a:focus-visible {\n  outline: 2px solid #ba160c;\n  outline-offset: 2px;\n}\n\n.a11y-error a {\n  color: #6ea8fe;\n}\n\n.a11y-error a:hover {\n  color: #9ec5fe;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
